import { Component, HostListener, NgZone, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDrawerMode, MatSidenav } from "@angular/material/sidenav";
import { Subscription } from "rxjs";
import { NavigationService } from "./providers/navigation.service";
import { TranslateServiceService } from "./providers/translate-service.service";
import { AngularFireMessaging } from "@angular/fire/messaging";
import { MessagingService } from "./providers/messaging.service";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { ViewportScroller } from "@angular/common";
import { ApiService } from "./providers/api.service";
import { NotificationService } from "./services/notification.service";
import firebase from 'firebase/app';
import * as Cookies from 'js-cookie';
import { SM_CONSTANTS } from "./shared/constants/sm-constants";
import { AuthService } from "./providers/auth.service";
import { AutoLoginLoaderService } from "./providers/auto-login-loader.service";
import { StorageService } from "./providers/storage.service";
import { AlertService } from "./providers/alert.service";
import { ConnectionService } from "ng-connection-service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LoaderServiceService } from "./providers/loader-service.service";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
    @HostListener('window:resize', ['$event'])
    onResize(event: any): void {
      // Check screen width on window resize
      this.checkScreenWidth();
    }
  hideMessagePanel: boolean = true;
  @ViewChild(MatSidenav)
  sideNav!: MatSidenav;
  bodyOffset: number = 64;
  sidenavMode: MatDrawerMode = "side";
  sideNavState: boolean = true;
  hideLayout: boolean = false;
  isFromHere: boolean = false;
  apisub:Subscription
  wasOffline = false;
  private _obsSubscription: Subscription = new Subscription();
  private notificationSubscription: Subscription = new Subscription();
  constructor(
    private apiservice: ApiService,

    private _alertService:AlertService,
    private storageservicce:StorageService,
    private _navService: NavigationService,
    public translate: TranslateServiceService,
    private angularFireMessaging: AngularFireMessaging,
    public messagingService: MessagingService,
    private router: Router,
    private viewportScroller: ViewportScroller,
    private notificationService: NotificationService,
    private translateservice: TranslateServiceService,
    private authService:AuthService,
    private ngzone: NgZone,
    private alloader:AutoLoginLoaderService,
    private snackBar: MatSnackBar,
    private connectionService : ConnectionService,
    private ls:LoaderServiceService, 
    private route: ActivatedRoute
  ) {
    this.router.events.subscribe(() => {
      this.checkCurrentRoute();
    });
    this.connectionService.monitor().subscribe(res=>{
      
      if (res.hasNetworkConnection || res.hasInternetAccess) {
        console.log('CONNECTION STATUS:::::>>>>>>',res);
        
          // this.noInternetConnection=false;
          // this.status = "ONLINE";
          if(this.wasOffline){
            this.wasOffline = false;
            this.ls.showLoader = false
            this.snackBar.dismiss();
            this.snackBar.open('Back online!', '', {
              duration: 3000,
              horizontalPosition: "center",
              verticalPosition: "top",
              panelClass: ['snack-success'],
            });
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        }else {
        console.log('CONNECTION STATUS:::::>>>>>>',res);
        // this.noInternetConnection=true;
        // this.status = "OFFLINE"
        if (!this.wasOffline) {
          this.wasOffline = true;
          this.ls.showLoader = false
          this.snackBar.dismiss();
          this.snackBar.open('You are offline!', '', {
            duration: 5000,
            horizontalPosition: "center",
            verticalPosition: "top",
            panelClass: ['snack-error'],
          });
          
          // this.showRetryDialog();
        }
        }
        // alert(this.status);
    },err=>{
      console.log(err);
    });
    this.translateservice.useLanguage('en');
    translate.getLanguage();
    this.messagingService.requestPermission();
    this.listenForAllNotifications();
   
    this.apisub = this.apiservice.apiResult.subscribe(res => {
      if (res.responseType === SM_CONSTANTS.GET_USER_DETAIL_RESULT) {
      
        if (res.result) {
          if (
            !res.result.profileHashId ||
            res.result.profileHashId == "null"
          ) {
            // this.authService.onSignOut();
          } else {
           
            this.storageservicce
              .getValueFromLocalStorage(SM_CONSTANTS.KEY_FCM_TOKEN)
              .then((value) => {
                console.log("valueiss", value);

                if (value && value != "null" && value != null) {
                  console.log("token exists");
                  console.log("tokenvalueis:::", value);
                  console.log(
                    "Notification granted value",
                    Notification.permission
                  );

                  if (
                    res.result.fcm_token !=
                      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
                    !res.result.fcm_token
                  ) {
                    // if(true){
                    // console.log("notEqualCheck", data.result.data[0].fcm_token != localStorage.getItem(UserConstants.KEY_FCM_TOKEN));
                    // console.log("notExistCheck", data.result.data[0].fcm_token==null);

                    if (Notification.permission == "granted") {
                      console.log("granted also true");

                      let bodyData = {
                        fcmToken: localStorage.getItem(
                          SM_CONSTANTS.KEY_FCM_TOKEN
                        ),
                      };

                      this.apiservice.updateFcmTokenInfo(
                        localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
                        bodyData
                      );
                    } else {
                      console.log("notification permission not granted");
                    }
                  }
                }
              });
          }
        }
      }
      if (res.responseType === SM_CONSTANTS.GET_USER_DETAIL_RESULT_TO_SET_COOKIE) {
        if (res.result) {


            
            //SETTING COOKIE FOR SSO
            let accId = localStorage.getItem(
              SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
            );
            let prfId = res.result.profileHashId;
            let aCountryCode = localStorage.getItem(
              SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE
            );
            let aPhone = localStorage.getItem(
              SM_CONSTANTS.KEY_NEW_ACCOUNT_PHONE_NUMBER
            );

            document.cookie = `accId=${accId};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;
            document.cookie = `prfId=${prfId};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;
            document.cookie = `aCountryCode=${aCountryCode};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;
            document.cookie = `aPhone=${aPhone};Domain=.lookzup.com;Max-Age=2592000;Path=/;`;


        }
      }

      if (res.responseType === SM_CONSTANTS.CHECK_USER_RESULT) {
        if(this.isFromHere){
          console.log(res);
          this.isFromHere = false
          if (res.result) {
            this.storageservicce.setLocalStorageValue(
              SM_CONSTANTS.KEY_NEW_ACCOUNT_PHONE_NUMBER,
              this.getCookie('aPhone')!
            );
            this.storageservicce.setLocalStorageValue(
              SM_CONSTANTS.KEY_ACCOUNT_COUNTRY_CODE,
              this.getCookie('aCountryCode')!
            );

            if (
              res.result.block_status &&
              res.result.block_status == '2'
            ) {
              this.authService.onSignOutWithoutRedirect()
              this.router.navigate(['/login'])
            } else {
              if (res.result.errorcode == '1') {
                this.storageservicce.setLocalStorageValue(
                  SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
                  res.result.accountHashID
                );

                //registered but no profile
                if (
                  !res.result.profile_hash ||
                  res.result.profile_hash == 'null'
                ) {
                  this.authService.onSignOutWithoutRedirect()
                  this.router.navigate(['/login'])
                  // this.showProfileForm = true;
                }

                //registered and having profie
                else if (
                  res.result.profile_hash &&
                  res.result.profile_hash != 'null'
                ) {
                  console.log('incoming');

                  //( make cases for mobile and laptop)
                  localStorage.setItem(
                    SM_CONSTANTS.PROFILE_HASH,
                    res.result.profile_hash
                  );
                  localStorage.setItem(
                    SM_CONSTANTS.PROFILE_CODE,
                    res.result.profile_code
                  );

                  this.router.navigateByUrl('/dashboard').then((_) => {
                    this.alloader.showLoader = false
                    
                    this._alertService.onOpenSnackbar('Logged in successfully');
                  });

                } else {
                  this._alertService.onOpenSnackbar(
                    'Some error occured. Please try again.'
                  );
                }
                this.apiservice.getUserDetail(localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID));
              } else if (res.result.errorcode == '0') {
                this.storageservicce.setLocalStorageValue(
                  SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
                  res.result.accountHashID
                );
                // this.showProfileForm = true;
              } else {
                this._alertService.onOpenSnackbar(res.result.message, 4000);
              }
            }
          }
        }

      }
    })


  }

  ngOnInit() {
    
    // Cookies.set('adf', 'valueWithSignature', { expires: 1, secure: true, sameSite: 'Strict' });

    const obsSub = this._navService.layoutConfig.subscribe((state) => {
      console.log(state);

      this.hideLayout = state.singlePage;
      this.sideNavState = !state.matches;
      this.bodyOffset = state.matches ? 56 : 64;
      this.sidenavMode = state.matches ? "push" : "side";
    });
    this._obsSubscription.add(obsSub);



     // COOKIE PRESENT
     if(this.getCookie('fbid') && this.getCookie('fbid') != 'null' && this.getCookie('fbid') != undefined){
      this.renewAllCookies(30);
      // ACCOUNT IDS PRESENT
      if (
        localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) &&
        localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) != 'null' && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID) && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID) != 'null'
      ){
        console.log('Statement::::COOKIE EXIST AND LOCAL ACCOUNT IDS EXIST -> LOGIN VIA LOCAL');

        this.apiservice.getUserDetail(
          localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
        );
      }
      // ACCOUNT IDS ABSENT
      else{
        console.log('Statement::::COOKIE EXIST BUT LOCAL ACCOUNT IDS DOESNT EXIST -> AUTO LOGIN VIA COOKIE'); //NEED TO HIT HERE
        this.checkScreenWidth()
        if(this.currentScreenWidth >= 1200){
          this.ngzone.run(() => {
            this.router.navigate(['/auto-login'])
          })
          this.authService.autoLogin().then(res => {
            if(res){
              console.log(res);
              this.isFromHere = true
              this.alloader.showLoader = false
              localStorage.setItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID, this.getCookie('fbid')!);
              const apiBodyData = {
                versionCode: '1.0.0',
                appType: 'web',
                appName: 'business',
                countryCode: this.getCookie('aCountryCode')
              }
  
              this.alloader.showLoader = true
              this.apiservice.checkUser(apiBodyData, this.getCookie('fbid')!, this.getCookie('aPhone')!);
            }
  
          })
          .catch(err => console.error(err));
          // this.authService.onSignOutWithoutMessage();
        }
        else{
          // REDIRECT TO LOGIN PAGE AND SHOW THE PLACEHOLDER
          console.log("inside redirection block");
          sessionStorage.setItem(SM_CONSTANTS.SMALLER_DEVICES, '1')
          // this.router.navigate(['/login'],{queryParams:   {hi:'hello'}})
          
        }

        }
    }
    // COOKIE ABSENT
    else{
      // ACCOUNT IDS PRESENT
      if (
        localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) && 
        localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID) != 'null' && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID) && localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_AUTH_ID) != 'null'
      ){
        console.log('Statement::::COOKIE DOESNT EXIST BUT LOCAL ACCOUNT IDS EXIST -> LOGGING OUT');
        if(environment.production){
          this.authService.onSignOutWithoutMessage();

        }
      }
      else{
        // APPROPRIATE ACTION ACCORDING TO APP (COULD BE 'DO NOTHING')
        console.log('Statement::::COOKIE DOESNT EXIST AND LOCAL ACCOUNT IDS DOESNT EXIST -> APP SPECIFIC ACTION');
        this.authService.onSignOutWithoutMessage();
      }
    }


  }

  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  
  checkCurrentRoute() {
    // Add the routes where you want to hide the sm-message-panel
    const routesToHidePanel = ['/login', '/register', '/', '/messages', '/auto-login']; // Add other routes as needed

    const currentPath = this.router.url.split('?')[0];

    this.hideMessagePanel = routesToHidePanel.includes(currentPath);
  }

  checkCurrentRouteForQuery() {
    const routesToNotShowPopup = [
      '/businesses/details/joining-query-list',
      '/all-bookings'
    ];
  
    // Get the current URL path without query parameters
    const currentPath = this.router.url.split('?')[0];
  
    // Check if the current path matches any route in the list
    if (routesToNotShowPopup.includes(currentPath)) {
      return false;
    }
    return true;
  }

  listenForAllNotifications() {
    this.notificationSubscription = this.notificationService.getAllNotifications()
      .subscribe(payload => {
        this.handleNotificationByType(payload);
      });
  }

  handleNotificationByType(payload: any) {
    const type = payload.data.type;
    switch (type) {
      // case 'newbooking':
      //   this.handleNewBooking(payload);
      //   break;
      case 'updateMessageThread':
        this.handleMessageThreadUpdate(payload);
        break;
      case 'newJoiningQuery':
        this.handleNewQuery(payload);
        break;
      case 'membershipQueryStatusUpdated':
        this.handleQueryStatusUpdate(payload);
        break;
      case 'onMemberAttendance':
        this.handleMemberAttendance(payload);
        break;
      case 'onBusinessActivation':
        this.handleMemberAttendance(payload);
        break;
      // Add other cases as needed
      default:
        console.log('new notification recieved', payload)
        this.apiservice.getMessageNotificationStatus()
    }
  }


  handleMessageThreadUpdate(payload: any) {
    console.log("new message received", payload);
    this.apiservice.getMessageNotificationStatus() //STOP THIS IF ITS ON THE MESSAGE SCREEN
  }
  handleNewQuery(payload: any) {
    console.log("new notification received", payload);
    if(this.checkCurrentRouteForQuery()){
      this.createNotification(payload.data.title, payload.data.message)

    }
    this.apiservice.getMessageNotificationStatus() //STOP THIS IF ITS ON THE QUERIES/show all SCREEN
  }
  handleQueryStatusUpdate(payload: any) {
    console.log("new notification received", payload);
    if(this.checkCurrentRouteForQuery()){
      this.createNotification(payload.data.title, payload.data.message)

    }
    this.apiservice.getMessageNotificationStatus() //STOP THIS IF ITS ON THE QUERIES/show all SCREEN
  }
  handleMemberAttendance(payload: any) {
    console.log("new notification received", payload);
    if(this.checkCurrentRouteForQuery()){
      this.createNotification(payload.data.title, payload.data.message)

    }
    this.apiservice.getMessageNotificationStatus() //STOP THIS IF ITS ON THE QUERIES/show all SCREEN
  }
  handleActivationDeactivation(payload: any) {
    console.log("new notification received", payload);
    this.createNotification(payload.data.title, payload.data.message)
  
    this.apiservice.getMessageNotificationStatus() //STOP THIS IF ITS ON THE QUERIES/show all SCREEN
  }

  ngOnDestroy() {
    this._obsSubscription.unsubscribe();
  }

  getAuthTokenFromCookie(): string | null {
    const cookies = document.cookie.split("; ");
    console.log('coooooo', cookies);
    
    const authCookie = cookies.find(row => row.startsWith("authId="));
    return authCookie ? authCookie.split("=")[1] : null;
  }

  getCookie(name: string): string | null {
    const matches = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return matches ? decodeURIComponent(matches[1]) : null;
  }

  renewAllCookies(days:any) {
    
    let cookies = document.cookie.split("; ");
    
    cookies.forEach(cookie => {
        let [name, value] = cookie.split("=");

        if (name && value) {
            let expires = new Date();
            expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000)); // Extend expiration
            
            document.cookie = `${name}=${value}; Domain=.lookzup.com; Expires=${expires.toUTCString()};Path=/;`;
        }
    });
}

currentScreenWidth:any
private checkScreenWidth(): void {
  this.currentScreenWidth = window.innerWidth;
  console.log(this.currentScreenWidth);
  
  
 
}

}




// OLD FCM PERMISSION CODE
// document.addEventListener("DOMContentLoaded", function () {
//   if (!Notification) {
//     alert(
//       "Desktop notifications not available in your browser. Try Chromium."
//     );
//     return;
//   }

//   if (Notification.permission !== "granted")
//     Notification.requestPermission();
//   //  alert("Please allow notifications permission to receive live updates on our platform.")
// });